// extracted by mini-css-extract-plugin
export default {"privacy":"style-module__privacy___yAhJu","privacy__content":"style-module__privacy__content___zXWod"};